// Shared automatic spot assessment for the Ocean Guide map and social posts.
// Keep presentation, manual overrides and recommendation selection outside it.
import { hasStrongWindSafetyStop } from "./oceanSpotCondition.mjs";
const angleDiff = (a, b) => {
  const diff = Math.abs(a - b) % 360;
  return diff > 180 ? 360 - diff : diff;
};
const exposureFactor = angle => angle <= 30 ? 1 : angle <= 60 ? 0.75 : angle <= 90 ? 0.5 : angle <= 120 ? 0.25 : 0.1;
const rank = { best: 3, good: 2, caution: 1, bad: 0 };

const seaStateCeiling = (wave, swell) => {
  if (wave >= 1.5 || swell >= 1.3) return "bad";
  if (wave >= 1 || swell >= 0.8) return "caution";
  if (wave >= 0.6 || swell >= 0.5) return "good";
  return "best";
};

const windRating = (speed, sheltered) => {
  if (speed <= 3) return "best";
  if (speed <= (sheltered ? 7 : 4)) return "good";
  if (speed <= (sheltered ? 9 : 7)) return "caution";
  return "bad";
};

export const getAutomaticMarineConditionType = (spot, {
  windDegree, windSpeed, windGust = 0, maxWindSpeed = 0, windItems = [], wave, swell, rainy = false,
  typhoonAffected = false,
}) => {
  if (hasStrongWindSafetyStop({ windSpeed, windGust, maxWindSpeed, windItems, typhoonAffected })) return "bad";
  const hasFacing = typeof spot.facing === "number" && typeof windDegree === "number" && !Number.isNaN(windDegree);
  const angle = hasFacing ? angleDiff(windDegree, spot.facing) : 0;
  const shelteredByWind = hasFacing && angle > 110;
  const feltSpeed = Math.max(windSpeed, windGust * 0.65, shelteredByWind ? 0 : maxWindSpeed || 0);
  const effectiveSpeed = feltSpeed * exposureFactor(angle);
  let ceiling = rainy ? "bad" : seaStateCeiling(wave, swell);
  if (!rainy && shelteredByWind) {
    if (ceiling === "caution") ceiling = "good";
    if (ceiling === "bad") ceiling = "caution";
  }
  const wind = windRating(effectiveSpeed, shelteredByWind);
  let type = rank[ceiling] <= rank[wind] ? ceiling : wind;
  if (spot.sheltered && wind === "bad" && type === "bad" && ceiling !== "bad") type = "good";
  return type;
};
